export default function WhyDirectMail() {
    const WhyDM = [
        {
            title: 'Reliable Results',
            desc: 'Many of our users see strong returns and continue to invest more each year.',
            img: 'reliable.webp',
        },
        {
            title: 'High Engagement',
            desc: 'Expect better response rates compared to many digital methods.',
            img: 'highengagement.webp',
        },
        {
            title: 'Growing Popularity',
            desc: 'More marketers are turning to direct mail to complement their strategies.',
            img: 'popularity.webp',
        },
    ]
    return (
        <div
            id="whydirectmail"
            className="max-w-full w-[1200px] mx-auto md:mt-16 mb-16">
            <div className="text-center space-y-8 md:px-10 pt-5">
                <h3 className="font-bold text-4xl md:text-[42px]/[1.15]">
                    <span>Why </span>
                    <span className="olm-gradient-text">Direct Mail</span>
                    <span>?</span>
                </h3>
                <div className="flex flex-row lg:flex-nowrap flex-wrap w-full lg:space-x-4 lg:space-y-0 space-y-6 px-4">
                    {WhyDM.map((why, i) => (
                        <div
                            className="lg:w-1/3 w-full bg-olm-gradient-t-to-b p-px rounded-[20px] text-[#1e1e1e] shadow-[0_16px_12px_rgba(0,0,0,0.04)]"
                            key={i}>
                            <div className="h-full flex flex-col items-center bg-white lg:p-8 p-6 py-12 space-y-4 rounded-[20px]">
                                <img
                                    src={`/assets/get-started/whydm/${why.img}`}
                                    alt={why.title}
                                    width={100}
                                    height={100}
                                />

                                <h3 className="font-bold text-2xl/7 text-[#1e1e1e]">
                                    {why.title}
                                </h3>
                                <p className="md:text-xl/normal md:text-[#444241] text-base/6 text-[#1e1e1e]">
                                    {why.desc}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
